<template>
  <div class="Lift">
    <el-carousel
      v-if="visi"
      :interval="element.style.interval"
      arrow="always"
      @change="change"
    >
      <el-carousel-item
        v-for="item in list"
        :key="item.elevatorDeviceId"
      >
        <div class="box">
          <div class="left">
            <div class="wrapping">
              <div class="txt">
                升降机名称
              </div>
              <div class="name">
                {{ item.elevatorName }}
              </div>
            </div>
            <div class="wrapping">
              <div class="txt">
                在线状态
              </div>
              <div
                class="name red"
                :class="{green:item.deviceStatus=='1'}"
              >{{ item.deviceStatus=='1'?'在线':'离线' }}</div>
            </div>
            <div class="wrapping">
              <div class="txt">
                报警状态
              </div>
              <div
                class="name green"
                :class="{red:item.alarmStatus=='1'}"
              >{{ item.alarmStatus=='1'?'报警':'正常' }}</div>
            </div>
          </div>
          <div class="img">
            <img
              src="../../../../../../../assets/images/custom-screen/lift/img.png"
              alt=""
            />
          </div>
          <div
            class="list"
            :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
          >
            <div class="item">
              <div class="label">
                额定承载人数
              </div>
              <div class="num">
                {{ detail.ratedPeopleCnt }}
              </div>
            </div>
            <div class="item">
              <div class="label">
                升降机类型
              </div>
              <div class="num">
                {{ detail.elevatorType=='0'?'单':detail.elevatorType=='1'?'左':'右' }}笼
              </div>
            </div>
            <div class="item">
              <div class="label">
                额定高度
              </div>
              <div class="num">
                {{ detail.ratedHeight }}M
              </div>
            </div>
            <div class="item">
              <div class="label">
                最高楼层
              </div>
              <div class="num">
                {{ detail.maxFloor }}层
              </div>
            </div>
            <div class="item">
              <div class="label">
                额定载重
              </div>
              <div class="num">
                {{ detail.ratedWeight }}吨
              </div>
            </div>
            <div class="item">
              <div class="label">
                最低楼层
              </div>
              <div class="num">
                {{ detail.minFloor }}层
              </div>
            </div>
            <div class="item">
              <div class="label">
                额定上行速度
              </div>
              <div class="num">
                {{ detail.ratedUpSpeed }}m/s
              </div>
            </div>
            <div class="item">
              <div class="label">
                额定倾角X
              </div>
              <div class="num">
                {{ detail.ratedObliguityX }}°
              </div>
            </div>
            <div class="item">
              <div class="label">
                额定下行速度
              </div>
              <div class="num">
                {{ detail.ratedDownSpeed }}m/s
              </div>
            </div>
            <div class="item">
              <div class="label">
                额定倾角Y
              </div>
              <div class="num">
                {{ detail.ratedObliguityY }}°
              </div>
            </div>
            <div class="item">
              <div class="label">
                额定风速
              </div>
              <div class="num">
                {{ detail.ratedWindSpeed }}m/s
              </div>
            </div>
            <div class="item">
              <div class="label">
                额定风级
              </div>
              <div class="num">
                {{ detail.ratedWindLevel }}级
              </div>
            </div>

          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  siteElevatorDeviceList,
  siteElevatorDeviceQueryDetail
} from '@/api/device'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
export default {
  props: {
    propValue: {
      type: String,
      default: ''
    },
    areaIdList: {
      type: [String, Array],
      default: ''
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [],
      index: 0,
      detail: {},
      visi: true
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    })
  },
  watch: {
    'element.style.interval': {
      deep: true,
      handler(val) {
        this.visi = false
        this.$nextTick(() => {
          this.visi = true
        })
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    changeDevicePixelRatio,
    getData() {
      siteElevatorDeviceList({
        projectId: this.projectItem.projectId,
        pageSize: 9999,
        pageNumber: 1
      }).then((res) => {
        this.list = res.data.records
        this.getDetail()
      })
    },
    change(e) {
      this.index = e
      this.getDetail()
    },
    getDetail() {
      if (this.list[this.index]) {
        siteElevatorDeviceQueryDetail({
          id: this.list[this.index].elevatorDeviceId
        }).then((res) => {
          this.detail =
            res.data.siteElevatorDeviceParam || res.data.siteElevatorDevice
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Lift {
  width: 100%;
  height: 100%;
  position: relative;
  .el-carousel {
    height: 100%;
  }
  .box {
    display: flex;
    color: #fff;
    height: 100%;
    padding-top: 3%;
    .left {
      height: 100%;
      width: 28%;
      .wrapping {
        background: #00468e;
        border-radius: 4px;
        width: 70%;
        margin: 0 auto;
        text-align: center;
        padding: 3% 0;
        margin-bottom: 5%;
        .txt {
          line-height: 1.3;
        }
        .name {
          line-height: 1.3;
        }
      }
    }
    .img {
      width: 40%;
      margin-left: 5%;
      position: relative;
      .desc {
        position: absolute;
        top: 0;
        left: 10%;
        transform: translate(0, -100%);
      }
      .desc1 {
        position: absolute;
        top: 4%;
        left: 0%;
      }
      .desc2 {
        position: absolute;
        top: 4%;
        right: 0%;
      }
      .desc3 {
        position: absolute;
        top: 50%;
        left: 0%;
      }
      img {
        width: 100%;
      }
    }
    .list {
      flex: 1;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-right: 2%;
      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #00468e;
        width: 48%;
        margin: 0 auto;
        padding: 3% 4%;
        margin-bottom: 4%;
        border-radius: 4px;

        .info {
          text-align: center;
          height: auto;
        }
      }
    }
  }
}
</style>
<style >
.Lift .el-carousel__container {
  height: 100%;
}
</style>
